import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const initializeSwiperDepoSejaNucleon = () => {
  const depoimentosSection = document.getElementById("depoimentos-nucleon");
  if (!depoimentosSection) return;

  let slidesPorGrupo = 3;
  let totalSlides = depoimentosSection.querySelectorAll(".mySwiperDepoimentosNucleon .swiper-slide").length;
  const duracao = 8000;

  const swiper = new Swiper(".mySwiperDepoimentosNucleon", {
    slidesPerView: slidesPorGrupo,
    slidesPerGroup: 1,
    spaceBetween: 32,
    loop: false,
    allowTouchMove: true,
    navigation: {
      nextEl: ".swiper-depoimentosNucleon-next",
      prevEl: ".swiper-depoimentosNucleon-prev",
    },
    breakpoints: {
      0: { slidesPerView: 1, slidesPerGroup: 1 },
      768: { slidesPerView: 2, slidesPerGroup: 1 },
      1024: { slidesPerView: 3, slidesPerGroup: 1 },
    },
    watchOverflow: true,
  });

  let grupoAtual = 0;
  let progressoTimer = null;

  const progressContainer = depoimentosSection.querySelector(".swiper-progress-nucleon");

  function getTotalGrupos() {
    return Math.ceil(totalSlides / slidesPorGrupo);
  }

  function criarBarras() {
    if (!progressContainer) return;

    progressContainer.innerHTML = ""; // Limpa as barras anteriores
    const totalGrupos = getTotalGrupos();

    for (let i = 0; i < totalGrupos; i++) {
      const barra = document.createElement("div");
      barra.setAttribute("data-slide", i);

      // Estilo da barra inativa
      Object.assign(barra.style, {
        width: "298px",
        height: "8px",
        background: "rgba(0, 0, 0, 0.20)",
        borderRadius: "8px",
        position: "relative",
        overflow: "hidden",
        cursor: "pointer",
        marginRight: "8px", // espaçamento entre barras
        display: "inline-block",
      });

      const fill = document.createElement("div");

      // Estilo da barra preenchida (ativa)
      Object.assign(fill.style, {
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "0px",
        background: "linear-gradient(to right, #129900, #AEFF00)",
        borderRadius: "8px",
        transition: "width 0.05s linear",
      });

      barra.appendChild(fill);
      progressContainer.appendChild(barra);

      barra.addEventListener("click", () => {
        clearInterval(progressoTimer);
        mostrarGrupo(i);
      });
    }
  }

  function barraFills() {
    return depoimentosSection.querySelectorAll(".swiper-progress-nucleon div div");
  }

  function atualizarNumeracao() {
    const atualEl = depoimentosSection.querySelector("#grupo-atual");
    const totalEl = depoimentosSection.querySelector("#grupo-total");

    if (atualEl && totalEl) {
      atualEl.textContent = String(grupoAtual + 1).padStart(2, "0");
      totalEl.textContent = String(getTotalGrupos()).padStart(2, "0");
    }
  }

  function resetarBarras() {
    barraFills().forEach((fill) => {
      fill.style.width = "0px";
    });
  }

  function iniciarBarra(grupoIndex) {
    resetarBarras();

    const fills = barraFills();
    const barraAtual = fills[grupoIndex % fills.length];
    if (!barraAtual) return;

    let largura = 0;
    const incremento = 298 / (duracao / 50);

    clearInterval(progressoTimer);
    progressoTimer = setInterval(() => {
      largura += incremento;
      if (largura >= 298) {
        barraAtual.style.width = "298px";
        clearInterval(progressoTimer);
        grupoAtual = (grupoAtual + 1) % getTotalGrupos();
        mostrarGrupo(grupoAtual);
      } else {
        barraAtual.style.width = `${largura}px`;
      }
    }, 50);
  }

  function mostrarGrupo(index) {
    grupoAtual = index;
    swiper.slideTo(grupoAtual * slidesPorGrupo, 600);
    atualizarNumeracao();
    iniciarBarra(grupoAtual);
  }

  const botaoProximo = depoimentosSection.querySelector(".swiper-depoimentosNucleon-next");
  if (botaoProximo) {
    botaoProximo.addEventListener("click", () => {
      clearInterval(progressoTimer);
      mostrarGrupo(grupoAtual >= getTotalGrupos() - 1 ? 0 : grupoAtual + 1);
    });
  }

  const botaoAnterior = depoimentosSection.querySelector(".swiper-depoimentosNucleon-prev");
  if (botaoAnterior) {
    botaoAnterior.addEventListener("click", () => {
      clearInterval(progressoTimer);
      mostrarGrupo(grupoAtual > 0 ? grupoAtual - 1 : getTotalGrupos() - 1);
    });
  }

  swiper.on('breakpoint', () => {
    slidesPorGrupo = swiper.params.slidesPerView;
    totalSlides = depoimentosSection.querySelectorAll(".mySwiperDepoimentosNucleon .swiper-slide").length;
    criarBarras();
    mostrarGrupo(0);
  });

  window.addEventListener("resize", () => {
    atualizarNumeracao();
  });

  // Inicialização
  criarBarras();
  mostrarGrupo(0);
};

export default initializeSwiperDepoSejaNucleon;
